import React, { useEffect, useState } from 'react';
import { Button, Card, Carousel, Col, Container, Form, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Pagination from '../../Common/Pagination';
import Lottie from 'react-lottie';
import ImageLoader from '../../../Assets/ImageLoader.json';
import NoImage from '../../../Assets/NoImage.svg';
import { ToastContainer, toast } from "react-toastify";
import { imageOption } from '../../../utils/consant';
import { useSelector } from 'react-redux';


const Rejected = () => {
    const userState = useSelector(state => state.loginData.userData);
    const financialYear = useSelector((state) => state.activeData.financialYear);

    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: ImageLoader,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    }

    const [loader, setLoader] = useState(false);
    const [category, setCategory] = useState('propertyImg');
    const [data, setData] = useState('');

    // Search by Mobile----
    const [searchMobile, setSearchMobile] = useState("");
    const [zoneList, setZoneList] = useState([]);
    const [searchZoneKey, setSearchZoneKey] = useState("");

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState();


    // function for pagination
    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1)
        setDocPerPage(docsPageProp);
    }

    useEffect(() => {
        getVerificationImages();
    }, [pageNo, docPerPage, category, financialYear])

    useEffect(() => {
        getZoneList();
    }, []);

    // get verification data
    const getVerificationImages = async () => {
        setLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/billDistribution/getRejectedBillImages', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                visitingPersonContactNo: searchMobile,
                ...(userState?.usertype_keyname?.includes("admin") || userState?.usertype_keyname?.includes("zonalofficer")
                    ? {
                        zonekey: userState?.usertype_keyname?.includes("admin")
                            ? searchZoneKey
                            : userState?.usertype_keyname?.includes("zonalofficer")
                                ? userState?.zonekey
                                : ""
                    }
                    : {}),
                // zonekey: userState?.usertype_keyname?.includes("admin") ? searchZoneKey : userState?.usertype_keyname?.includes("zonalofficer") ? userState?.zonekey : "",
                ...(userState?.usertype_keyname?.includes("gatlipik") && {
                    gatkey: userState?.gatkey
                }),
                imageField: category,
                documentsPerPage: docPerPage,
                page: pageNo,
                financialYear: financialYear,
            })
        }).then((res) => res.json()).then((response) => {
            setData(response);
            setNoOfPages(response?.noOfPages);
            setLoader(false);
        }).catch((Err) => {
            console.log("Err while getting surveys images", Err);
            setLoader(false);
        })
    }

    // for zone list data
    const getZoneList = async () => {
        await fetch(process.env.REACT_APP_BASE_URL +
            "/zoneData/getZoneData"
            , {
                method: "GET",
            })
            .then((res) => res.json())
            .then((response) => {
                setZoneList(response.data);
            })
            .catch((err) => {
                console.log("Error While Fetching Zone List", err);
            });
    };



    // for search by mobile number
    const searchByMobile = () => {
        if (searchMobile.length !== 10) {
            toast.error("Please Enter Valid Mobile Number.");
        } else {
            getVerificationImages();
        }
    };

    // for search by zone
    const searchByZone = () => {
        if (searchZoneKey.length < 0) {
            toast.error("Please Select Zone first.");
        } else {
            getVerificationImages();
        }
    };

    return (
        <div className='visitReport SurveyImages'>
            <Container>
                {/* for search by mobile number and zone */}
                <Row className="justify-content-center">
                    <Col md={4} className="searchCard m-2">
                        <div className="label mb-2 mx-auto">
                            <p>Search by mobile</p>
                        </div>
                        <div className="d-flex mt-1">
                            <Form.Control
                                className="me-3"
                                placeholder="Enter mobile number"
                                value={searchMobile}
                                name="contactNo"
                                onChange={(e) => {
                                    if (
                                        !e.target.value.match(
                                            /[A-Za-z+@#$&%!~=*./\s/g/\-/?<>,"/]/
                                        ) && e.target.value.length <= 10
                                    ) {
                                        setSearchMobile(e.target.value);
                                    }
                                }}
                            />

                            <Button className="btn-submit" onClick={searchByMobile}>
                                <Icon.Search className="me-2" size={14} />
                                Search
                            </Button>
                        </div>
                    </Col>

                    {
                        userState?.usertype_keyname?.includes("admin") &&
                        <Col md={4} className="searchCard m-2">
                            <div className="label mb-2 mx-auto">
                                <p>Search by Zone</p>
                            </div>
                            <div className="d-flex mt-1">
                                <Form.Select
                                    className="me-2"
                                    value={searchZoneKey}
                                    onChange={(e) => setSearchZoneKey(e.target.value)}
                                >
                                    <option value="" selected disabled>
                                        Select Zone
                                    </option>
                                    {zoneList !== undefined && zoneList.length > 0 ? (
                                        zoneList.map((row) => {
                                            return (
                                                <option value={row.zonekey}>
                                                    {row.zonename + "-" + row.zoneno}
                                                </option>
                                            );
                                        })
                                    ) : (
                                        <option value="">No Data Found</option>
                                    )}
                                </Form.Select>
                                <Button className="btn-submit" onClick={searchByZone}>
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </div>
                        </Col>
                    }
                    <Col md={4} className="searchCard m-2">
                        <div className="label mb-2 mx-auto">
                            <p>Search by Image Category</p>
                        </div>
                        <div className="d-flex mt-1">
                            <Form.Select
                                className="me-2"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <option value="" selected disabled>
                                    {" "}
                                    Select Image Category
                                </option>
                                {imageOption !== undefined && imageOption.length > 0 ? (
                                    imageOption.map((opt, index) => {
                                        return (
                                            <option key={index} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        );
                                    })
                                ) : (
                                    <option value="">No Data Found</option>
                                )}
                            </Form.Select>
                        </div>
                    </Col>
                </Row>

                {/* for fetching image verification data */}
                {loader ?
                    <div style={{ height: '65vh' }} className='d-flex justify-content-center align-items-center'>
                        <center><Lottie options={LottieOptions} className='mt-3' width={500} />Images Loading...</center>
                    </div> :
                    <Row className='mt-4'>
                        {
                            data?.data !== null && data?.data !== undefined && data?.data?.length > 0 ?
                                data?.data?.map((itm, index) => {
                                    const isImage = String(itm[category]).endsWith('.jpg') || String(itm[category]).endsWith('.jpeg') || String(itm[category]).endsWith('.png');
                                    const isVideo = String(itm[category]).endsWith('.mp4') || String(itm[category]).endsWith('.mov') || String(itm[category]).endsWith('.avi');
                                    return (
                                        <React.Fragment key={index} >
                                            {itm[category]?.length > 1 ? (
                                                <Col md={3} className='mb-4' data-aos="fade-up">
                                                    <Card className='h-100'>
                                                        <Carousel>
                                                            {itm[category]?.map((image, imageIndex) => {
                                                                const isImage = image.endsWith('.jpg') || image.endsWith('.jpeg') || image.endsWith('.png');
                                                                const isVideo = image.endsWith('.mp4') || image.endsWith('.mov') || image.endsWith('.avi');
                                                                return (
                                                                    <Carousel.Item key={imageIndex}>
                                                                        <div className='card-img-wrapper position-relative'>
                                                                            {isImage && <img className='cardImg' src={image} alt={category} height={250} width='100%' style={{ border: '2px solid rgba(255, 0, 0, 0.817)' }} />}
                                                                            {isVideo && <video width='100%' height={250} controls> <source src={image} type="video/mp4" style={{ border: '2px solid rgba(255, 0, 0, 0.817)' }} /></video>}
                                                                        </div>
                                                                    </Carousel.Item>
                                                                )

                                                            })}
                                                        </Carousel>
                                                        <Card.Body>
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <h6>{itm?.visitingPersonName}</h6>
                                                                    <p>{itm?.visitingPersonContactNo}</p>
                                                                </div>
                                                                <div className="text-end">
                                                                    <h6>{itm?.zonename}</h6>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <h6><span className='fw-bold'>Reason :</span> {itm?.propertyImgRejectRsn}</h6>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ) : itm[category] === null ?
                                                <Col md={3} className='mb-4' data-aos="fade-up">
                                                    <Card className='h-100 justify-content-center align-items-center'>
                                                        <div className='mt-2'>
                                                            <img src={NoImage} alt="No Image" height={100} width='100%' />
                                                            <Card.Body>
                                                                <div className="d-flex justify-content-between">
                                                                    <div>
                                                                        <h6>{itm?.visitingPersonName}</h6>
                                                                        <p>{itm?.visitingPersonContactNo}</p>
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <h6>{itm?.zonename}</h6>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <h6><span className='fw-bold'>Reason : </span>{itm?.propertyImgRejectRsn}</h6>
                                                                </div>
                                                            </Card.Body>
                                                        </div>
                                                    </Card>
                                                </Col> : (
                                                    <Col md={3} className='mb-4' data-aos="fade-up">
                                                        <Card className='h-100'>
                                                            <div className='card-img-wrapper position-relative'>
                                                                {isImage && <img className='cardImg' src={itm[category]} alt={category} height={250} width='100%' style={{ border: '2px solid rgba(255, 0, 0, 0.817)' }} />}
                                                                {isVideo && <video width='100%' height={250} controls> <source src={itm[category]} type="video/mp4" style={{ border: '2px solid rgba(255, 0, 0, 0.817)' }} /></video>}
                                                            </div>
                                                            <Card.Body>
                                                                <div className="d-flex justify-content-between">
                                                                    <div>
                                                                        <h6>{itm?.visitingPersonName}</h6>
                                                                        <p>{itm?.visitingPersonContactNo}</p>
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <h6>{itm?.zonename}</h6>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <h6><span className='fw-bold'>Reason : </span>{itm?.propertyImgRejectRsn}</h6>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                )}
                                        </React.Fragment>
                                    )
                                })
                                : 'No data Found'
                        }
                    </Row>
                }

                <Row>
                    <Col md={4} className='d-flex align-items-center mt-3 mt-md-0'>
                        <h6 className='text-start mb-0'>
                            <Icon.People className='me-2' />Total - <strong>{data?.count ? data?.count : '0'}</strong>
                        </h6>
                    </Col>
                    <Col md={8} className='d-flex justify-content-end p-md-0'>
                        <Pagination currentPage={pageNo} totalPages={noOfPages} onPageChange={handlePageChange}
                            onDocsPerPage={handleDocsPerPage} docsPerPage={docPerPage} />
                    </Col>
                </Row>
            </Container>

        </div >
    )
}

export default Rejected